import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveExtensionPhoneMutation = gql`
   mutation SaveExtensionPhones($extensionPhones: [ExtensionPhoneInput!]!) {
      saveExtensionPhones(extensionPhones: $extensionPhones) {
         extensionPhoneId
         office
      }
   }
`;
